export type UsageColour = "error" | "warning" | "success";

export const usageColour = (percentUsed: number, errorAbove: number, warningAbove: number): UsageColour =>
  percentUsed > errorAbove ? "error" : percentUsed > warningAbove ? "warning" : "success";

export const neqUsageColour = (percentUsed: number) => usageColour(percentUsed, 85, 65);
